/* eslint-disable i18next/no-literal-string */
import { useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { AggregateTrackerConfig } from 'utils/analytics/trackers/aggregate-tracker';
import PublicEnv from 'shared/utils/public-env';

/**
 * Provides the configuration used by the aggregate tracker to create individual trackers.
 */
export const useTrackerConfig = (): AggregateTrackerConfig | null => {
  const flags = useFlags();
  const siftEnabled = flags['rollout.marketplace-sift-tracker'];
  const internalGTMEnabled = flags['rollout.internal-gtm-tracker'];
  const { siftBeaconKey, segmentAnalyticsKey: segmentKey } = PublicEnv;

  const trackerConfigs = useMemo(
    () => ({
      internalGTMEnabled,
      segmentKey,
      siftBeaconKey,
      siftEnabled,
    }),
    [internalGTMEnabled, segmentKey, siftBeaconKey, siftEnabled]
  );

  return trackerConfigs;
};
